import type { KeycapId } from "@/components/keycap/keycapCatalog";

export interface HomeInsight {
  id: string;
  number: string;
  title: string;
  body: string;
  keycap: KeycapId;
  link: { label: string; to: string };
}

/**
 * The four ideas that carry the homepage. One sentence and one key each — no
 * diagrams, no bullet lists. See the 2026-07-17 keycap art-direction pass:
 * the brand is the canvas and composition, told through a keyset, not a
 * generic tile.
 */
export const homeInsights: HomeInsight[] = [
  {
    id: "compose",
    number: "01",
    title: "Compose",
    body: "Build software from qualified engineering components instead of rebuilding it from scratch.",
    keycap: "compose",
    link: { label: "Components", to: "/components" },
  },
  {
    id: "connect",
    number: "02",
    title: "Connect",
    body: "Components become executable systems on a visual engineering canvas.",
    keycap: "connect",
    link: { label: "The canvas", to: "/canvas" },
  },
  {
    id: "qualify",
    number: "03",
    title: "Qualify",
    body: "Every graph is tested, validated and integrity-checked before it is trusted or published.",
    keycap: "qualify",
    link: { label: "Qualification", to: "/qualification" },
  },
  {
    id: "publish",
    number: "04",
    title: "Publish",
    body: "Qualified components are reused across projects and teams, and browsable today in the public Marketplace catalogue.",
    keycap: "publish",
    link: { label: "Marketplace", to: "/marketplace" },
  },
];
